import { SVGProps } from "react";

export default function CopyLinkIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, stroke = "#444D5A", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M10.6693 8.59967V11.3997C10.6693 13.733 9.73594 14.6663 7.4026 14.6663H4.6026C2.26927 14.6663 1.33594 13.733 1.33594 11.3997V8.59967C1.33594 6.26634 2.26927 5.33301 4.6026 5.33301H7.4026C9.73594 5.33301 10.6693 6.26634 10.6693 8.59967Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6693 4.59967V7.39967C14.6693 9.73301 13.7359 10.6663 11.4026 10.6663H10.6693V8.59967C10.6693 6.26634 9.73594 5.33301 7.4026 5.33301H5.33594V4.59967C5.33594 2.26634 6.26927 1.33301 8.6026 1.33301H11.4026C13.7359 1.33301 14.6693 2.26634 14.6693 4.59967Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
